import React from 'react';
// @ts-ignore
import AboutImage from '../../assets/1.png';
import { FaArrowRight, FaWhatsapp } from 'react-icons/fa';
const Features = () => {
  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-6 text-center">
      <h2 className="text-4xl font-bold text-gray-800 mb-12"></h2>
        <div className="flex flex-col md:flex-row justify-around">
         {/* Left Content */}
      <div className="w-full lg:w-1/2">
        <div className="space-y-6">
          <h2 className="text-4xl lg:text-4xl font-bold text-gray-800 leading-tight">
            Brief Information <br />
             <span className="text-[#6cbb23] hover:text-green-700"><strong>About Us</strong></span>
          </h2>
          <p className="mt-4 text-gray-600 pb-8 text-justify">
            We are a smart digital solution for restaurants and hotels. We provide an interactive digital menu that allows customers to browse, order, and enjoy a seamless dining experience. With every order, businesses can collect customers' WhatsApp numbers, enabling them to offer personalized experiences, exclusive promotions, and direct communication. Our platform helps restaurants boost engagement, increase sales, and build long-term customer relationships. Elevate your service with our innovative digital menu system today!
          </p>
          <a
            href="https://zafflo.com/menu/zafflo-demo" target = "_blank"
            className="bg-gradient-to-br from-purple-500 to-pink-500 text-white px-8 py-2 rounded-full text-xl font-bold shadow-xl animate-bounce"
          >
            View Sample Menu
          
          </a>
        </div>
      </div>

      {/* Right Image */}
      <div className="w-full lg:w-1/2 mt-10">
        <img
          src={AboutImage}
          alt="About"
          className="w-full max-w-md mx-auto"
        />
      </div>

       
        </div>
      </div>
    </section>
  );
};

export default Features;